import {
  _sharedReducerMainTree,
  _sharedStateMainTree
} from "@/shared/store/mainTree/reducer";

export const initialState = _sharedStateMainTree;

const mainTreeReducer =  (state = initialState, action) => {
  switch (action.type) {
    default:
      return _sharedReducerMainTree(state, action);
  }
};

export default mainTreeReducer;
